import { render, staticRenderFns } from "./SeletorDeFormaDePagamento.vue?vue&type=template&id=5b2ae3a9&"
import script from "./SeletorDeFormaDePagamento.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeFormaDePagamento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
